import { create } from "zustand";
import { persist } from "zustand/middleware";

const usePersistData = create(
  persist(
    (set) => ({
      user: null,
      setUser: (userData) =>
        set((state) => ({
          user: userData,
        })),
    }),
    {
      name: "portal-store",
      getStorage: () => localStorage,
    }
  )
);

export default usePersistData;
